// components/Logo.js
import Image from "next/image"

const Logo = ({ size = 40 }) => {
  return (
    <div className="flex items-center justify-center">
      <Image
        src="/logo.png"
        alt="Roset Logo"
        width={size}
        height={size}
        className="object-contain rounded-full"
        priority
      />
    </div>
  )
}

export default Logo
